// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React, { HTMLAttributes, ReactNode } from "react";

import { EditableProps } from "components/Editor/EditablePropsType";
import { Fbt } from "fbt";
import { cx } from "style/utils";
import { getDefaultQuestionDefinition } from "components/ui/Questionnaire/QuestionnaireUtils";
import useBulletListStyle from "../../style/useBulletListStyle";

interface DeclarativeListProps extends HTMLAttributes<HTMLUListElement> {
  items?: Array<string | Fbt>;
  children?: ReactNode;
}

export const DeclarativeListEditableProps: EditableProps = {
  item: {
    ...getDefaultQuestionDefinition(),
    name: "item",
    label: "item",
    mandatory: true,
    valueType: "string",
  },
};

export type DeclarativeListComponent = (
  props: DeclarativeListProps
) => React.ReactElement;

const DeclarativeList: DeclarativeListComponent = (
  props: DeclarativeListProps
) => {
  const { items, children, className, ...rest } = props;
  return (
    <ul className={cx(useBulletListStyle().bulletList, className)} {...rest}>
      {items && items.map((item, index) => <li key={"ul_" + index}>{item}</li>)}
      {children}
    </ul>
  );
};

export default DeclarativeList;
